import { IQPlayerDataItem } from '../../interfaces';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';
import { play, stop } from '../../domain/audio-provider';

interface IPlaylistItemProps {
    playlistItem: IQPlayerDataItem;
}

const PlaylistItem = ({ playlistItem }: IPlaylistItemProps) => {

    const dispatch = useAppDispatch();

    const selected = useAppSelector(store => store.root.selected);
    const selectedClass = `px-4 py-2 text-left ${ selected?.id === playlistItem.id ? 'bg-purple-100 rounded-xl' : '' }`;
    const isPlaying = useAppSelector(store => store.root.isPlaying);
    const isBypass = useAppSelector(store => store.root.isBypass);
    const isDelta = useAppSelector(store => store.root.isDelta);
    const audioContext = useAppSelector(store => store.root.audioContext);

    const data = useAppSelector(store => store.root.data);
    const activeColor = data?.settings?.activeColor || '#E29E39';

    const onClick = () => {
        let _selected: IQPlayerDataItem|null = playlistItem;

        if(isPlaying) {
            stop(selected, isBypass, isDelta);
            _selected = play(audioContext, _selected, false, false);
        }

        dispatch(
            rootActions.main({
                selected: _selected,
                isBypass: false,
                isDelta: false,
            })
        )
    };

    return (
        <button
            onClick={ onClick }
            type="button"
            className={ selectedClass }
            style={{
                backgroundColor: (selected?.id === playlistItem.id) ? activeColor : '',
            }}>
            { playlistItem.name }
        </button>
    )
};

export default PlaylistItem;